<script>
	import { borgPassives, collectiveRewards, collectiveTrackList, collectiveValues } from '../../../borg';
    import CardOperations from '../../ops/CardOperations.svelte';
	import BoardBase from '../BoardBase.svelte';
    import { dbHover, dbUnhover } from '../dashfuncs';
	import Mission from '../Mission.svelte';
	import CustomTrackIcons from './CustomTrackIcons.svelte';

	export let board;
	const isAdvanced = true;
	export let p;
	export let isPreview = false;

	function makeOps(){
		let bits = borgPassives();
		let ops = [];
		for(let t of bits){
			let [type, text] = t.allText.split(':').map(b => b.trim());
			type = type.toLowerCase();
			ops.push({type, text});
		}
		return ops;
	}
	
	// no jiggling just now
	let markerMagicNumbers = [
		[0, 23.2], [-1, 28.8], [0, 34.3], [-1, 40], [0, 45.5], [-1, 51], [0, 56.5], [-1, 62], [0, 67.6], [-1, 73.3],
		[15.5, 96], [22.5, 96], [29.7, 96], [36.8, 96], [44, 96], [51.2, 96], [58.2, 96], [65.4, 96], [72.4, 96], [79.3, 96],
		[94.5, 73.1], [94.5, 67.6], [94.5, 62], [94.5, 56.5], [94.5, 51], [94.5, 45.4], [94.5, 39.9], [94.5, 34.3], [94.5, 28.7], [94.5, 23.3],
		[79.5, 0], [73, 0], [65.5, 0], [58.4, 0], [51, 0], [44, 0], [36.9, 0], [29.8, 0], [22.5, 0], [15.3, 0],
		[44, 16.5]
	]

	function getMarkerPosition(c){
		let nums = markerMagicNumbers[c];
		return `top: ${nums[0]}%; left: ${nums[1]}%;`
	}

</script>

<BoardBase {p} deck="" side="advanced" hideSideLabel customImage={"./assets/board-borg.png"} preview={isPreview}
	on:mouseenter={e => {dbHover(e, p, isPreview, 'all')}}
	on:mousemove={e => {dbHover(e, p, isPreview, 'all')}}
	on:mouseleave={e => {dbUnhover(e, p)}} 
>
	<svelte:fragment slot="missions">
		<div class="position-override">
			<div class="mission-container">
				<Mission {p} preview={isPreview} mission={board.missions[0]} {isAdvanced} />
			</div>
			<div class="info-container mission">
				<CardOperations operations={makeOps()} />
			</div>
		</div>
	</svelte:fragment>
	<svelte:fragment slot="tracks">
		<CustomTrackIcons
			length={10}
			values={collectiveTrackList()}
			valueOffset={0}
			direction="row"
			topPct={10.25}
			leftPct={21.8}
			currentValue={p.collective}
		/>
		<CustomTrackIcons
			length={10}
			values={collectiveTrackList()}
			valueOffset={10}
			direction="column"
			topPct={13.5}
			leftPct={86}
			currentValue={p.collective}
		/>
		<CustomTrackIcons
			length={10}
			values={collectiveTrackList()}
			valueOffset={20}
			direction="row-reverse"
			topPct={82.5}
			leftPct={21.8}
			currentValue={p.collective}
		/>
		<CustomTrackIcons
			length={10}
			values={collectiveTrackList()}
			valueOffset={30}
			direction="column-reverse"
			topPct={14}
			leftPct={8.25}
			currentValue={p.collective}
		/>
		<div class="marker" style={getMarkerPosition(p.collective)}></div>
	</svelte:fragment>
</BoardBase>

<style lang="scss">
	.position-override {
		position: relative;
		width: 100%;
		height: 100%;
	}
	.mission-container {
		position: absolute;
		top: 188%;
		left: 3%;
		width: 65%;
		scale: 1.2;
		& :global(.mission-title svg) {
			width: 1.5em;
		}
	}
	.info-container {
		position: absolute;
		top: 84%;
		left: 49%;
		display: flex;
		flex-direction: row;
		gap: 10px;
		max-width: 40%;
		height: fit-content;
		scale: 1.2;
		& :global(.op-text) {
			line-height: 1.2em;
		}
	}

	.marker {
		position: absolute;
		width: calc(var(--height) / 11);
    	height: calc(var(--height) / 11);
		outline: 2px solid white;
		transition: left 0.5s, top 0.5s;
		background-color: lime;
	}
</style>
